import "core-js/modules/es6.array.map";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.array.slice";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import React, { useContext, useRef, useState, useEffect, useCallback } from 'react';
import t from 'prop-types';
import { useSpring, animated } from 'react-spring';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
var classnames = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  /* global define */

  (function () {
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
      var classes = [];
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;
        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
          var inner = classNames.apply(null, arg);
          if (inner) {
            classes.push(inner);
          }
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }
      return classes.join(' ');
    }
    if (module.exports) {
      classNames["default"] = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});
var tokens = {
  spacing: ['none', 'xxsmall', 'xsmall', 'smallish', 'small', 'gutter', 'medium', 'large', 'largeish', 'xlarge', 'xxlarge', 'full', 'half'],
  textSizes: ['xsmall', 'small', 'standard', 'large', 'xlarge'],
  display: ['none', 'inline', 'block', 'flex', 'grid'],
  background: ['brand', 'brandAccent', 'critical', 'transparent', 'secondary', 'subtle', 'neutral'],
  foreground: ['brand', 'brandAccent', 'critical', 'secondary', 'subtle', 'link', 'neutral'],
  alignItems: ['flex-start', 'flex-end', 'center', 'baseline', 'stretch'],
  justifyContent: ['flex-start', 'flex-end', 'center', 'space-around', 'space-between', 'stretch'],
  position: ['relative', 'absolute', 'fixed', 'sticky', 'static'],
  overflow: ['hidden', 'visible', 'auto', 'scroll']
};
var validateResponsiveProps = function validateResponsiveProps(tokenValues) {
  return function (props, propName, componentName) {
    var propValue = props[propName];
    if (!propValue) {
      return;
    }
    var error = new Error("Invalid prop ".concat(propName, ": ").concat(propValue, " supplied to ").concat(componentName, ". Expected one or more spacing props ").concat(tokenValues));
    if (Array.isArray(propValue) && !propValue.every(function (val) {
      return tokenValues.includes(val);
    })) {
      return error;
    }
    if (!Array.isArray(propValue) && !tokenValues.includes(propValue)) {
      return error;
    }
  };
};
var spacing = validateResponsiveProps(tokens.spacing);
var display = validateResponsiveProps(tokens.display);
var alignItems = validateResponsiveProps(tokens.alignItems);
var justifyContent = validateResponsiveProps(tokens.justifyContent);
var position = validateResponsiveProps(tokens.position);
var overflow = validateResponsiveProps(tokens.overflow);
var backgroundContext = React.createContext();
var BackgroundProvider = backgroundContext.Provider;
var renderBackgroundProvider = function renderBackgroundProvider(background, element) {
  return background && background !== 'transparent' ? /*#__PURE__*/React.createElement(BackgroundProvider, {
    value: background
  }, element) : element;
};
var useBackground = function useBackground() {
  return useContext(backgroundContext);
};
renderBackgroundProvider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "renderBackgroundProvider"
};
var ctx = React.createContext();
var Provider = ctx.Provider;
var ThemeProvider = Provider;
var useTheme = function useTheme() {
  var theme = useContext(ctx);
  return theme;
};
var resolveResponsiveClassnames = function resolveResponsiveClassnames(element, value, label) {
  if (value != null) {
    if (Array.isArray(value)) {
      return value.map(function (v, i) {
        return "u-".concat(element, "--").concat(label, "-").concat(v, "-").concat(i);
      });
    }
    return "u-".concat(element, "--").concat(label, "-").concat(value, "-0");
  }
};
var responsiveClassnames = function responsiveClassnames(breakpoints, value, label) {
  var breakpointNames = Object.keys(breakpoints);
  if (value != null) {
    if (Array.isArray(value)) {
      return value.map(function (v, i) {
        if (i === 0) {
          return "".concat(label, "-").concat(v);
        }
        return "".concat(label, "-").concat(v, ":").concat(breakpointNames[i - 1]);
      });
    }
    return "".concat(label, "-").concat(value);
  }
};
var useBoxStyles = function useBoxStyles(_ref) {
  var _ref2, _ref3;
  var as = _ref.as,
    background = _ref.background,
    boxShadow = _ref.boxShadow,
    display = _ref.display,
    flexDirection = _ref.flexDirection,
    alignItems = _ref.alignItems,
    alignSelf = _ref.alignSelf,
    justifyContent = _ref.justifyContent,
    align = _ref.align,
    justify = _ref.justify,
    flexGrow = _ref.flexGrow,
    flexShrink = _ref.flexShrink,
    padding = _ref.padding,
    paddingTop = _ref.paddingTop,
    paddingRight = _ref.paddingRight,
    paddingBottom = _ref.paddingBottom,
    paddingLeft = _ref.paddingLeft,
    paddingX = _ref.paddingX,
    paddingY = _ref.paddingY,
    margin = _ref.margin,
    marginTop = _ref.marginTop,
    marginRight = _ref.marginRight,
    marginBottom = _ref.marginBottom,
    marginLeft = _ref.marginLeft,
    marginX = _ref.marginX,
    marginY = _ref.marginY,
    position = _ref.position,
    size = _ref.size,
    overflow = _ref.overflow,
    overflowX = _ref.overflowX,
    overflowY = _ref.overflowY,
    minHeight = _ref.minHeight,
    height = _ref.height,
    maxHeight = _ref.maxHeight,
    minWidth = _ref.minWidth,
    width = _ref.width,
    maxWidth = _ref.maxWidth,
    flexWrap = _ref.flexWrap,
    wrap = _ref.wrap,
    gridTemplateColumns = _ref.gridTemplateColumns,
    gridGap = _ref.gridGap,
    gridRowGap = _ref.gridRowGap,
    gridColumnGap = _ref.gridColumnGap,
    borderRadius = _ref.borderRadius;
  var theme = useTheme();
  var classes = function classes(value, label) {
    return responsiveClassnames(theme ? theme.breakpoints : {}, value, label);
  };
  var resolvedPaddingTop = paddingTop || paddingY || padding;
  var resolvedPaddingBottom = paddingBottom || paddingY || padding;
  var resolvedPaddingLeft = paddingLeft || paddingX || padding;
  var resolvedPaddingRight = paddingRight || paddingX || padding;
  var resolvedMarginTop = marginTop || marginY || margin;
  var resolvedMarginBottom = marginBottom || marginY || margin;
  var resolvedMarginLeft = marginLeft || marginX || margin;
  var resolvedMarginRight = marginRight || marginX || margin;
  var paddingClasses = classes(padding, 'p');
  var paddingXClasses = !paddingClasses && classes(paddingX, 'px');
  var paddingYClasses = !paddingClasses && classes(paddingY, 'py');
  var paddingTopClasses = !paddingClasses && !paddingYClasses && classes(resolvedPaddingTop, 'pt');
  var paddingRightClasses = !paddingClasses && !paddingXClasses && classes(resolvedPaddingRight, 'pr');
  var paddingBottomClasses = !paddingClasses && !paddingYClasses && classes(resolvedPaddingBottom, 'pb');
  var paddingLeftClasses = !paddingClasses && !paddingXClasses && classes(resolvedPaddingLeft, 'pl');
  var marginClasses = classes(margin, 'p');
  var marginXClasses = !marginClasses && classes(marginX, 'mx');
  var marginYClasses = !marginClasses && classes(marginY, 'my');
  var marginTopClasses = !marginClasses && !marginYClasses && classes(resolvedMarginTop, 'mt');
  var marginRightClasses = !marginClasses && !marginXClasses && classes(resolvedMarginRight, 'mr');
  var marginBottomClasses = !marginClasses && !marginYClasses && classes(resolvedMarginBottom, 'mb');
  var marginLeftClasses = !marginClasses && !marginXClasses && classes(resolvedMarginLeft, 'ml');
  return [paddingClasses, paddingYClasses, paddingXClasses, paddingTopClasses, paddingRightClasses, paddingBottomClasses, paddingLeftClasses, marginClasses, marginXClasses, marginYClasses, marginTopClasses, marginRightClasses, marginBottomClasses, marginLeftClasses, classes(minHeight, 'minHeight'), classes(height, 'height'), classes(maxHeight, 'maxHeight'), classes(minWidth, 'minWidth'), classes(width, 'width'), classes(maxWidth, 'maxWidth'), classes(display, 'display'), classes(flexDirection, 'flex-direction'), classes(flexShrink, 'flex-shrink'), classes(flexGrow, 'flex-grow'), classes(size, 'size'), classes(alignItems || align, 'flex-alignItems'), classes(alignSelf, 'flex-alignSelf'), classes(justifyContent || justify, 'flex-justifyContent'), classes(position, 'position'), classes(overflow, 'overflow'), classes(overflowX, 'overflowX'), classes(overflowY, 'overflowY'), classes(gridTemplateColumns, 'grid-template-cols'), classes(gridGap, 'gap'), classes(gridRowGap, 'row-gap'), classes(gridColumnGap, 'col-gap'), classes(borderRadius, 'radius'), (_ref2 = {}, _defineProperty(_ref2, "bg-".concat(background), background), _defineProperty(_ref2, "flex-wrap", wrap || flexWrap), _ref2), (_ref3 = {}, _defineProperty(_ref3, "shadow-".concat(boxShadow), boxShadow && (!background || background === 'transparent')), _defineProperty(_ref3, "shadow-".concat(boxShadow, "-on-").concat(background), boxShadow && background && background !== 'transparent'), _ref3)];
};
var Box = React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    background = _ref.background,
    className = _ref.className,
    padding = _ref.padding,
    paddingTop = _ref.paddingTop,
    paddingRight = _ref.paddingRight,
    paddingBottom = _ref.paddingBottom,
    paddingLeft = _ref.paddingLeft,
    paddingX = _ref.paddingX,
    paddingY = _ref.paddingY,
    margin = _ref.margin,
    marginTop = _ref.marginTop,
    marginRight = _ref.marginRight,
    marginBottom = _ref.marginBottom,
    marginLeft = _ref.marginLeft,
    marginX = _ref.marginX,
    marginY = _ref.marginY,
    boxShadow = _ref.boxShadow,
    display = _ref.display,
    flexDirection = _ref.flexDirection,
    alignItems = _ref.alignItems,
    alignSelf = _ref.alignSelf,
    justifyContent = _ref.justifyContent,
    align = _ref.align,
    justify = _ref.justify,
    flexGrow = _ref.flexGrow,
    flexShrink = _ref.flexShrink,
    position = _ref.position,
    size = _ref.size,
    minHeight = _ref.minHeight,
    height = _ref.height,
    maxHeight = _ref.maxHeight,
    minWidth = _ref.minWidth,
    width = _ref.width,
    maxWidth = _ref.maxWidth,
    overflow = _ref.overflow,
    overflowX = _ref.overflowX,
    overflowY = _ref.overflowY,
    wrap = _ref.wrap,
    flexWrap = _ref.flexWrap,
    gridTemplateColumns = _ref.gridTemplateColumns,
    gridGap = _ref.gridGap,
    gridRowGap = _ref.gridRowGap,
    gridColumnGap = _ref.gridColumnGap,
    borderRadius = _ref.borderRadius,
    props = _objectWithoutProperties(_ref, ["as", "background", "className", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "boxShadow", "display", "flexDirection", "alignItems", "alignSelf", "justifyContent", "align", "justify", "flexGrow", "flexShrink", "position", "size", "minHeight", "height", "maxHeight", "minWidth", "width", "maxWidth", "overflow", "overflowX", "overflowY", "wrap", "flexWrap", "gridTemplateColumns", "gridGap", "gridRowGap", "gridColumnGap", "borderRadius"]);
  var boxStyles = useBoxStyles({
    as: as,
    background: background,
    padding: padding,
    paddingTop: paddingTop,
    paddingRight: paddingRight,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    paddingX: paddingX,
    paddingY: paddingY,
    margin: margin,
    marginTop: marginTop,
    marginRight: marginRight,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    marginX: marginX,
    marginY: marginY,
    boxShadow: boxShadow,
    display: display,
    flexDirection: flexDirection,
    alignItems: alignItems,
    alignSelf: alignSelf,
    justifyContent: justifyContent,
    align: align,
    justify: justify,
    flexGrow: flexGrow,
    flexShrink: flexShrink,
    position: position,
    size: size,
    minHeight: minHeight,
    height: height,
    width: width,
    overflow: overflow,
    overflowX: overflowX,
    overflowY: overflowY,
    wrap: wrap,
    flexWrap: flexWrap,
    gridTemplateColumns: gridTemplateColumns,
    gridGap: gridGap,
    gridRowGap: gridRowGap,
    gridColumnGap: gridColumnGap,
    borderRadius: borderRadius
  });
  var element = React.createElement(as, _objectSpread2({
    className: classnames(boxStyles, className),
    ref: ref
  }, props));
  return renderBackgroundProvider(background, element);
});
Box.propTypes = {
  /**
   * Renders the given component or element
   */
  as: t.any,
  /**
   * Sets the background color
   */
  background: t.string,
  /**
   * Adds the given class name
   */
  className: t.string,
  /**
   * Sets the display rule.
   */
  display: display,
  /**
   * Applies padding to all sides
   */
  padding: spacing,
  /**
   * Applies padding to the top
   */
  paddingTop: spacing,
  /**
   * Applies padding to the right
   */
  paddingRight: spacing,
  /**
   * Applies padding to the bottom
   */
  paddingBottom: spacing,
  /**
   * Applies padding to the left
   */
  paddingLeft: spacing,
  /**
   * Applies padding to the left and right
   */
  paddingX: spacing,
  /**
   * Applies padding to the top and bottom
   */
  paddingY: spacing,
  /**
   * Applies margin to all sides
   */
  margin: spacing,
  /**
   * Applies margin to the top
   */
  marginTop: spacing,
  /**
   * Applies margin to the right
   */
  marginRight: spacing,
  /**
   * Applies margin to the bottom
   */
  marginBottom: spacing,
  /**
   * Applies margin to the left
   */
  marginLeft: spacing,
  /**
   * Applies margin to the left and right
   */
  marginX: spacing,
  /**
   * Applies margin to the top and bottom
   */
  marginY: spacing,
  /**
   * Sets the CSS position
   */
  position: position,
  /**
   * Applies flex alignment to children (only applies to flex display)
   */
  align: alignItems,
  /**
   * Applies flex justification to children (only applies to flex display)
   */
  justify: justifyContent,
  /**
   * Sets the width and height equally
   */
  size: spacing,
  /**
   * Applies shadow styles and/or borders
   */
  boxShadow: t.string,
  /**
   * Defines overflow behavior on X and Y axis
   */
  overflow: overflow,
  /**
   * Defines overflow behavior on X axis
   */
  overflowX: overflow,
  /**
   * Defines overflow behavior on Y axis
   */
  overflowY: overflow,
  /**
   * Applies a set height
   */
  height: spacing,
  /**
   * Applies a set width
   */
  width: spacing,
  /**
   * Applies flex wrapping (only applies to flex display)
   */
  wrap: t.bool,
  /**
   * Applies flex grow value
   */
  flexGrow: t.number
};
Box.displayName = 'Box';
Box.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Box",
  "props": {
    "as": {
      "defaultValue": {
        "value": "'div'",
        "computed": false
      },
      "type": {
        "name": "any"
      },
      "required": false,
      "description": "Renders the given component or element"
    },
    "background": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Sets the background color"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Adds the given class name"
    },
    "display": {
      "type": {
        "name": "custom",
        "raw": "types.display"
      },
      "required": false,
      "description": "Sets the display rule."
    },
    "padding": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Applies padding to all sides"
    },
    "paddingTop": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Applies padding to the top"
    },
    "paddingRight": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Applies padding to the right"
    },
    "paddingBottom": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Applies padding to the bottom"
    },
    "paddingLeft": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Applies padding to the left"
    },
    "paddingX": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Applies padding to the left and right"
    },
    "paddingY": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Applies padding to the top and bottom"
    },
    "margin": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Applies margin to all sides"
    },
    "marginTop": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Applies margin to the top"
    },
    "marginRight": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Applies margin to the right"
    },
    "marginBottom": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Applies margin to the bottom"
    },
    "marginLeft": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Applies margin to the left"
    },
    "marginX": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Applies margin to the left and right"
    },
    "marginY": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Applies margin to the top and bottom"
    },
    "position": {
      "type": {
        "name": "custom",
        "raw": "types.position"
      },
      "required": false,
      "description": "Sets the CSS position"
    },
    "align": {
      "type": {
        "name": "custom",
        "raw": "types.alignItems"
      },
      "required": false,
      "description": "Applies flex alignment to children (only applies to flex display)"
    },
    "justify": {
      "type": {
        "name": "custom",
        "raw": "types.justifyContent"
      },
      "required": false,
      "description": "Applies flex justification to children (only applies to flex display)"
    },
    "size": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Sets the width and height equally"
    },
    "boxShadow": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Applies shadow styles and/or borders"
    },
    "overflow": {
      "type": {
        "name": "custom",
        "raw": "types.overflow"
      },
      "required": false,
      "description": "Defines overflow behavior on X and Y axis"
    },
    "overflowX": {
      "type": {
        "name": "custom",
        "raw": "types.overflow"
      },
      "required": false,
      "description": "Defines overflow behavior on X axis"
    },
    "overflowY": {
      "type": {
        "name": "custom",
        "raw": "types.overflow"
      },
      "required": false,
      "description": "Defines overflow behavior on Y axis"
    },
    "height": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Applies a set height"
    },
    "width": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Applies a set width"
    },
    "wrap": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Applies flex wrapping (only applies to flex display)"
    },
    "flexGrow": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Applies flex grow value"
    }
  }
};
var Text = function Text(_ref) {
  var _cx;
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'standard' : _ref$size,
    _ref$tone = _ref.tone,
    tone = _ref$tone === void 0 ? 'neutral' : _ref$tone,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? 'regular' : _ref$weight,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'left' : _ref$align,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? false : _ref$heading,
    _ref$baseline = _ref.baseline,
    baseline = _ref$baseline === void 0 ? true : _ref$baseline,
    _ref$block = _ref.block,
    block = _ref$block === void 0 ? false : _ref$block,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, ["size", "tone", "weight", "align", "heading", "baseline", "block", "className"]);
  var backgroundContext = useBackground();
  if (process.env.NODE_ENV === 'development' && Object.keys(props).length > 0) {
    Object.keys(props).forEach(function (prop) {
      if (prop.includes('padding') || prop.includes('margin')) {
        console.warn("Warning: You've added ".concat(prop, " to a Text Component, this could cause issues with the component's baseline cropping"));
      }
    });
  }
  var background = backgroundContext && backgroundContext !== 'transparent' ? backgroundContext : null;
  var classes = classnames((_cx = {
    text: !heading,
    heading: heading,
    'baseline-crop': baseline,
    'display-block': block
  }, _defineProperty(_cx, "tone-".concat(tone, "-on-").concat(background), background), _defineProperty(_cx, "tone-".concat(tone), tone), _defineProperty(_cx, "text-weight-".concat(weight), weight !== 'regular'), _defineProperty(_cx, "text-".concat(size), !heading), _defineProperty(_cx, "heading-".concat(size), heading), _cx), "text-align-".concat(align), className);
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: classes,
    as: "p"
  }, props));
};
Text.propTypes = {
  /**
   * Set size and line-height
   */
  size: t.oneOf(tokens.textSizes),
  /**
   * Set the font weight
   */
  weight: t.oneOf(['regular', 'medium', 'strong']),
  /**
   * Set the text color
   */
  tone: t.oneOf(tokens.foreground),
  /**
   * Set text alignment
   */
  align: t.oneOf(['left', 'center', 'right']),
  /**
   * Use heading font styles
   */
  heading: t.bool,
  /**
   * Strips space from top and bottom of text for precise alignment.
   */
  baseline: t.bool,
  /**
   * Applies block level styling
   */
  block: t.bool
};
Text.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Text",
  "props": {
    "size": {
      "defaultValue": {
        "value": "'standard'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "computed": true,
        "value": "types.tokens.textSizes"
      },
      "required": false,
      "description": "Set size and line-height"
    },
    "tone": {
      "defaultValue": {
        "value": "'neutral'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "computed": true,
        "value": "types.tokens.foreground"
      },
      "required": false,
      "description": "Set the text color"
    },
    "weight": {
      "defaultValue": {
        "value": "'regular'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'regular'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'strong'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Set the font weight"
    },
    "align": {
      "defaultValue": {
        "value": "'left'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'left'",
          "computed": false
        }, {
          "value": "'center'",
          "computed": false
        }, {
          "value": "'right'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Set text alignment"
    },
    "heading": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Use heading font styles"
    },
    "baseline": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Strips space from top and bottom of text for precise alignment."
    },
    "block": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Applies block level styling"
    }
  }
};
var Divider = function Divider(_ref) {
  var _ref$tone = _ref.tone,
    tone = _ref$tone === void 0 ? 'subtle' : _ref$tone,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, ["tone", "className"]);
  return /*#__PURE__*/React.createElement(Box, _extends({
    "aria-hidden": true,
    className: classnames("u-divider-".concat(tone), className)
  }, props));
};
Divider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Divider",
  "props": {
    "tone": {
      "defaultValue": {
        "value": "'subtle'",
        "computed": false
      },
      "required": false
    }
  }
};
var Stack = function Stack(_ref) {
  var _ref$space = _ref.space,
    space = _ref$space === void 0 ? 'gutter' : _ref$space,
    _ref$dividers = _ref.dividers,
    dividers = _ref$dividers === void 0 ? false : _ref$dividers,
    className = _ref.className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, ["space", "dividers", "className", "children"]);
  var classes = classnames(className);
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: classes,
    display: "flex",
    flexDirection: "column",
    align: "stretch",
    justify: "flex-start"
  }, props), React.Children.toArray(children).filter(function (i) {
    return i;
  }).map(function (child, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: child.key
    }, i > 0 && dividers && /*#__PURE__*/React.createElement(Divider, _extends({}, child.props.display && {
      display: child.props.display
    }, child.props.alignSelf && {
      alignSelf: child.props.alignSelf
    }, {
      marginTop: space,
      width: "full"
    })), /*#__PURE__*/React.createElement(Box, _extends({}, child.props.display && {
      display: child.props.display
    }, child.props.alignSelf && {
      alignSelf: child.props.alignSelf
    }, {
      marginTop: i > 0 ? space : undefined,
      maxWidth: "full"
    }), child));
  }));
};
Stack.propTypes = {
  /**
   * Applies spacing between child elements
   */
  space: spacing,
  /**
   * Render a divider between elements
   */
  dividers: t.bool
};
Stack.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Stack",
  "props": {
    "space": {
      "defaultValue": {
        "value": "'gutter'",
        "computed": false
      },
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Applies spacing between child elements"
    },
    "dividers": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Render a divider between elements"
    }
  }
};
var Inline = function Inline(_ref) {
  var _ref$space = _ref.space,
    space = _ref$space === void 0 ? 'gutter' : _ref$space,
    collapseBelow = _ref.collapseBelow,
    className = _ref.className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, ["space", "collapseBelow", "className", "children"]);
  var classes = classnames('u-inline', resolveResponsiveClassnames('inline', space, 'space'), {
    'u-inline--collapse-1': collapseBelow === 'tablet',
    'u-inline--collapse-2': collapseBelow === 'desktop'
  }, className);
  return /*#__PURE__*/React.createElement(Box, {
    className: classnames(resolveResponsiveClassnames('inline', space, 'container'))
  }, /*#__PURE__*/React.createElement(Box, _extends({
    align: "center",
    justify: "flex-start",
    wrap: true,
    className: classes
  }, props), React.Children.toArray(children).filter(function (i) {
    return i;
  }).map(function (child, i) {
    return /*#__PURE__*/React.createElement(Box, {
      key: child.key + i,
      className: "u-inline__item",
      paddingLeft: space,
      paddingTop: space,
      display: child.props && child.props.display,
      flexGrow: child.props && child.props.flexGrow
    }, child);
  })));
};
Inline.propTypes = {
  /**
   * Applies spacing between child elements
   */
  space: spacing
};
Inline.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Inline",
  "props": {
    "space": {
      "defaultValue": {
        "value": "'gutter'",
        "computed": false
      },
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Applies spacing between child elements"
    }
  }
};
var Icon = function Icon(_ref) {
  var _classNames;
  var name = _ref.name,
    url = _ref.url,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'gutter' : _ref$size,
    _ref$tone = _ref.tone,
    tone = _ref$tone === void 0 ? 'neutral' : _ref$tone,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, ["name", "url", "size", "tone", "className"]);
  var backgroundContext = useBackground();
  var background = backgroundContext && backgroundContext !== 'transparent' ? backgroundContext : null;
  var a11y = props.title && props.title.length ? {
    role: 'img'
  } : {
    'aria-hidden': 'true'
  };
  var classes = classnames('icon', (_classNames = {}, _defineProperty(_classNames, 'tone-inherit', !tone), _defineProperty(_classNames, "tone-".concat(tone, "-on-").concat(background), background), _defineProperty(_classNames, "tone-".concat(tone), tone), _classNames), className);
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    display: "block",
    size: size
  }, a11y, {
    className: classes
  }, props), /*#__PURE__*/React.createElement("use", {
    role: "presentation",
    xlinkHref: url ? url : "#".concat(name)
  }));
};
Icon.propTypes = {
  /**
   * SVG symbol ID from sprite
   */
  name: t.string,
  /**
   * SVG sprite url
   */
  url: t.string,
  /**
   * Sets the dimension (width/height) of the icon (passed to Box)
   */
  size: spacing
};
Icon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Icon",
  "props": {
    "size": {
      "defaultValue": {
        "value": "'gutter'",
        "computed": false
      },
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Sets the dimension (width/height) of the icon (passed to Box)"
    },
    "tone": {
      "defaultValue": {
        "value": "'neutral'",
        "computed": false
      },
      "required": false
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "SVG symbol ID from sprite"
    },
    "url": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "SVG sprite url"
    }
  }
};
var bg = function bg(weight) {
  switch (weight) {
    case 'regular':
      return 'brand';
    case 'strong':
      return 'brandAccent';
    default:
      return 'transparent';
  }
};
var Button = React.forwardRef(function (_ref, ref) {
  var _cx;
  var className = _ref.className,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? 'regular' : _ref$weight,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'regular' : _ref$size,
    icon = _ref.icon,
    iconRight = _ref.iconRight,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? 'small' : _ref$iconSize,
    _ref$innerJustify = _ref.innerJustify,
    innerJustify = _ref$innerJustify === void 0 ? false : _ref$innerJustify,
    _ref$loading = _ref.loading,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, ["className", "weight", "size", "icon", "iconRight", "iconSize", "innerJustify", "loading", "children"]);
  var hasChildren = React.Children.count(children) > 0;
  var iconOnly = !hasChildren && (icon || iconRight);
  var classes = classnames('u-button', "u-button--weight-".concat(weight), (_cx = {}, _defineProperty(_cx, "u-button--size-".concat(size), size), _defineProperty(_cx, "u-button--icon-only", iconOnly), _cx), className);
  var paddings = {
    xsmall: {
      x: 'small',
      y: 'xxsmall'
    },
    small: {
      x: 'small',
      y: 'xsmall'
    },
    regular: {
      x: 'gutter',
      y: 'smallish'
    },
    large: {
      x: 'medium',
      y: 'small'
    }
  };
  var fontSizes = {
    xsmall: 'small',
    small: 'small',
    regular: 'standard',
    large: 'large'
  };
  var paddingX = paddings[size].x;
  var paddingY = paddings[size].y;
  var text = hasChildren && /*#__PURE__*/React.createElement(Text, {
    className: "u-button__text",
    as: "div",
    baseline: true,
    size: fontSizes[size],
    tone: props.tone || (weight === 'link' ? 'link' : 'neutral'),
    align: "center",
    weight: "regular",
    display: children.props && children.props.display,
    block: true
  }, children);
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: "button",
    paddingX: props.paddingX || !iconOnly && paddingX,
    boxShadow: props.boxShadow || (weight === 'weak' ? 'borderStandard' : undefined),
    background: props.background || bg(weight),
    className: classes,
    type: "button"
  }, props), /*#__PURE__*/React.createElement(Box, {
    className: "u-button__inner",
    display: "flex",
    align: "center",
    justify: innerJustify ? 'space-between' : 'center'
  }, icon && /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    size: iconSize,
    className: "u-icon--".concat(icon),
    tone: props.tone || (weight === 'link' ? 'link' : 'neutral'),
    marginRight: hasChildren ? 'xsmall' : undefined
  }), text, iconRight && /*#__PURE__*/React.createElement(Icon, {
    name: iconRight,
    size: iconSize,
    className: "u-icon--".concat(iconRight),
    tone: props.tone || (weight === 'link' ? 'link' : 'neutral'),
    marginLeft: hasChildren ? 'xsmall' : undefined
  })));
});
Button.displayName = 'Button';
Button.propTypes = {
  /**
   * Sets the button's overall appearance
   */
  weight: t.oneOf(['regular', 'strong', 'weak', 'link']),
  /**
   * Sets the size of the button
   */
  size: t.oneOf(['small', 'regular', 'large']),
  /**
   * Render a given icon to the left of the text
   */
  icon: t.string,
  /**
   * Render a given icon to the right of the text
   */
  iconRight: t.string,
  /**
   * Sets the dimensions (width/height) of the icon
   */
  iconSize: spacing,
  /**
   * Justifies/spaces text and icon at each end (space-between).
   */
  innerJustify: t.bool,
  /**
   * Used to switch between the button contents and a loading spinner (not yet implemeted)
   */
  loading: t.bool
};
Button.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Button",
  "props": {
    "weight": {
      "defaultValue": {
        "value": "'regular'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'regular'",
          "computed": false
        }, {
          "value": "'strong'",
          "computed": false
        }, {
          "value": "'weak'",
          "computed": false
        }, {
          "value": "'link'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Sets the button's overall appearance"
    },
    "size": {
      "defaultValue": {
        "value": "'regular'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'regular'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Sets the size of the button"
    },
    "iconSize": {
      "defaultValue": {
        "value": "'small'",
        "computed": false
      },
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Sets the dimensions (width/height) of the icon"
    },
    "innerJustify": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Justifies/spaces text and icon at each end (space-between)."
    },
    "loading": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Used to switch between the button contents and a loading spinner (not yet implemeted)"
    },
    "icon": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Render a given icon to the left of the text"
    },
    "iconRight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Render a given icon to the right of the text"
    }
  }
};
var Columns = function Columns(_ref) {
  var _ref$cols = _ref.cols,
    cols = _ref$cols === void 0 ? 12 : _ref$cols,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? 'gutter' : _ref$gap,
    colGap = _ref.colGap,
    rowGap = _ref.rowGap,
    collapse = _ref.collapse,
    collapseBelowTablet = _ref.collapseBelowTablet,
    className = _ref.className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, ["cols", "gap", "colGap", "rowGap", "collapse", "collapseBelowTablet", "className", "children"]);
  var classes = classnames({
    'u-cols--collapse-0': collapse || collapseBelowTablet,
    'u-cols--collapse-1': collapseBelowTablet
  }, className);
  return /*#__PURE__*/React.createElement(Box, _extends({
    display: "grid",
    gridTemplateColumns: cols,
    gridGap: gap,
    gridColumnGap: colGap,
    gridRowGap: rowGap,
    className: classes
  }, props), children);
};
Columns.propTypes = {
  /**
   * Amount of columns in the grid
   */
  cols: t.oneOfType([t.arrayOf(t.number), t.number]),
  /**
   * Sets even spacing for columns and rows
   */
  gap: spacing,
  /**
   * Sets even spacing for columns and rows
   */
  colGap: spacing,
  /**
   * Sets even spacing for columns and rows
   */
  rowGap: spacing
};
Columns.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Columns",
  "props": {
    "cols": {
      "defaultValue": {
        "value": "12",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "number"
          }
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "Amount of columns in the grid"
    },
    "gap": {
      "defaultValue": {
        "value": "'gutter'",
        "computed": false
      },
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Sets even spacing for columns and rows"
    },
    "colGap": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Sets even spacing for columns and rows"
    },
    "rowGap": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Sets even spacing for columns and rows"
    }
  }
};
var Column = function Column(_ref) {
  var span = _ref.span,
    className = _ref.className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, ["span", "className", "children"]);
  var classes = classnames('u-col', resolveResponsiveClassnames('col', span, 'span'), className);
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: classes
  }, props), children);
};
Column.propTypes = {
  /**
   * Amount of columns to span
   */
  span: t.oneOfType([t.arrayOf(t.number), t.number])
};
Column.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Column",
  "props": {
    "span": {
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "number"
          }
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "Amount of columns to span"
    }
  }
};
var ContentBlock = function ContentBlock(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'large' : _ref$width,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, ["width", "className"]);
  var classes = classnames('u-content-block', "u-content-block--".concat(width), className);
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: classes,
    paddingX: "gutter"
  }, props));
};
ContentBlock.propTypes = {
  /**
   * Sets the maximum width of the element
   */
  width: t.oneOf(['medium', 'large', 'max'])
};
ContentBlock.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ContentBlock",
  "props": {
    "width": {
      "defaultValue": {
        "value": "'large'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }, {
          "value": "'max'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Sets the maximum width of the element"
    }
  }
};
var ScrollBox = function ScrollBox(_ref) {
  var className = _ref.className,
    _ref$scrollX = _ref.scrollX,
    scrollX = _ref$scrollX === void 0 ? false : _ref$scrollX,
    _ref$scrollY = _ref.scrollY,
    scrollY = _ref$scrollY === void 0 ? false : _ref$scrollY,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, ["className", "scrollX", "scrollY", "children"]);
  var classes = classnames('u-scrollbox', className);
  return /*#__PURE__*/React.createElement(Box, _extends({
    width: "full",
    position: "relative",
    overflow: "hidden",
    className: classes
  }, props), /*#__PURE__*/React.createElement(Box, {
    height: "full",
    width: "full",
    overflowX: scrollX ? 'scroll' : undefined,
    overflowY: scrollY ? 'scroll' : undefined,
    className: "u-scrollbox__wrapper"
  }, /*#__PURE__*/React.createElement(Box, {
    height: "full"
  }, children)));
};
ScrollBox.propTypes = {
  /**
   * Sets the Scrollbox to scroll horizontally through its overflow contents
   */
  scrollX: t.bool,
  /**
   * Sets the Scrollbox to scroll vertically through its overflow contents
   */
  scrollY: t.bool
};
ScrollBox.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ScrollBox",
  "props": {
    "scrollX": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Sets the Scrollbox to scroll horizontally through its overflow contents"
    },
    "scrollY": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Sets the Scrollbox to scroll vertically through its overflow contents"
    }
  }
};
var Swatch = function Swatch(_ref) {
  var name = _ref.name,
    src = _ref.src,
    _ref$lazy = _ref.lazy,
    selected = _ref.selected,
    size = _ref.size,
    className = _ref.className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, ["name", "src", "lazy", "selected", "size", "className", "children"]);
  var classes = classnames('u-swatch', {
    'u-swatch--selected': selected
  }, className);
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: classes,
    role: "button",
    "aria-label": name,
    size: size
  }, props), /*#__PURE__*/React.createElement(Box, {
    className: "u-swatch__inner"
  }, children));
};
Swatch.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Swatch",
  "props": {
    "lazy": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    }
  }
};
var _useIntersectionObserver = function _useIntersectionObserver() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var targetRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    inView = _useState2[0],
    setInView = _useState2[1];
  useEffect(function () {
    if (!window.IntersectionObserver) {
      return null;
    }
    var observer = new window.IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !inView) {
        setInView(true);
      }
    }, _objectSpread2({
      rootMargin: '100px',
      threshold: 0.1
    }, options));
    observer.observe(targetRef.current);
    return function () {
      if (typeof observer.unobserve === 'function') {
        observer.unobserve(targetRef.current);
      }
    };
  }, []);
  return [targetRef, inView];
};
var useImageLoadState = function useImageLoadState(args) {
  var imageRef = useRef(null);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loaded = _useState4[0],
    setLoaded = _useState4[1];
  var loadCallback = useCallback(function () {
    return setLoaded(true);
  });
  useEffect(function () {
    if (!imageRef || !imageRef.current) {
      return;
    }
    if (imageRef.current.complete) {
      setLoaded(true);
    } else {
      setLoaded(false);
      imageRef.current.addEventListener('load', loadCallback);
      return function () {
        return imageRef.current.removeEventListener('load', loadCallback);
      };
    }
  }, _toConsumableArray(args));
  return [imageRef, loaded];
};
var useLazyImage = function useLazyImage() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 ? arguments[1] : undefined;
  var _useIntersectionObser = _useIntersectionObserver(opts),
    _useIntersectionObser2 = _slicedToArray(_useIntersectionObser, 2),
    viewRef = _useIntersectionObser2[0],
    inView = _useIntersectionObser2[1];
  var _useImageLoadState = useImageLoadState([inView].concat(_toConsumableArray(args))),
    _useImageLoadState2 = _slicedToArray(_useImageLoadState, 2),
    imageRef = _useImageLoadState2[0],
    loaded = _useImageLoadState2[1];
  return {
    viewRef: viewRef,
    inView: inView,
    imageRef: imageRef,
    loaded: loaded
  };
};
var Image = function Image(_ref) {
  var src = _ref.src,
    alt = _ref.alt,
    srcSet = _ref.srcSet,
    sizes = _ref.sizes,
    imageProps = _ref.imageProps,
    fluid = _ref.fluid,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '100%' : _ref$height,
    _ref$springConfig = _ref.springConfig,
    springConfig = _ref$springConfig === void 0 ? function () {
      return {};
    } : _ref$springConfig,
    _ref$lazy = _ref.lazy,
    lazy = _ref$lazy === void 0 ? true : _ref$lazy,
    props = _objectWithoutProperties(_ref, ["src", "alt", "srcSet", "sizes", "imageProps", "fluid", "width", "height", "springConfig", "lazy"]);
  var _useLazyImage = useLazyImage({
      rootMargin: '200px'
    }, [src]),
    viewRef = _useLazyImage.viewRef,
    imageRef = _useLazyImage.imageRef,
    inView = _useLazyImage.inView,
    loaded = _useLazyImage.loaded;
  var ready = !lazy || loaded && inView;
  var _springConfig = {
    opacity: ready ? 1 : 0,
    width: fluid ? '100%' : width,
    config: {
      tension: 500,
      friction: 30
    },
    immediate: !lazy
  };
  var style = useSpring(_objectSpread2({}, _springConfig, {}, springConfig(ready)));
  var aspectRatio = height / width * 100;
  return /*#__PURE__*/React.createElement(animated.div, {
    style: style
  }, /*#__PURE__*/React.createElement(Box, _extends({
    className: "u-image",
    ref: viewRef,
    style: {
      paddingTop: "".concat(aspectRatio, "%")
    }
  }, props), /*#__PURE__*/React.createElement("img", _extends({
    ref: imageRef,
    alt: alt || '',
    src: !lazy || inView ? src : undefined,
    srcSet: !lazy || inView ? srcSet : undefined,
    sizes: sizes
  }, imageProps)), /*#__PURE__*/React.createElement("noscript", null, "<img src=\"".concat(src, "\" alt=\"").concat(alt, "\" style=\"display: block; max-width: 100%;\" />"))));
};
Image.propTypes = {
  /**
   * The image src HTML attribute
   */
  src: t.string,
  /**
   * The image alt HTML attribute
   */
  alt: t.string,
  /**
   * The image srcset HTML attribute
   */
  srcSet: t.string,
  /**
   * The image sizes HTML attribute
   */
  sizes: t.string,
  /**
   * Additional HTML attributes to pass to the img element
   */
  imageProps: t.any,
  /**
   * If true, the image fills its container width-wise while maintaining the aspect ratio from width/height
   */
  fluid: t.bool,
  /**
   * If true, uses IntersectionObserver to prevent loading until entering the viewport
   */
  lazy: t.bool,
  /**
   * Sets the width of the image. If 'fluid' is true, width is used to calculate the aspect ratio
   */
  width: t.oneOfType([t.string, t.number]),
  /**
   * Sets the height of the image. If 'fluid' is true, height is used to calculate the aspect ratio
   */
  height: t.oneOfType([t.string, t.number]),
  /**
   * Custom function to control fade-in animation when `lazy` is true
   */
  springConfig: t.func
};
Image.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Image",
  "props": {
    "width": {
      "defaultValue": {
        "value": "'100%'",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "Sets the width of the image. If 'fluid' is true, width is used to calculate the aspect ratio"
    },
    "height": {
      "defaultValue": {
        "value": "'100%'",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "Sets the height of the image. If 'fluid' is true, height is used to calculate the aspect ratio"
    },
    "springConfig": {
      "defaultValue": {
        "value": "() => ({})",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Custom function to control fade-in animation when `lazy` is true"
    },
    "lazy": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "If true, uses IntersectionObserver to prevent loading until entering the viewport"
    },
    "src": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The image src HTML attribute"
    },
    "alt": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The image alt HTML attribute"
    },
    "srcSet": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The image srcset HTML attribute"
    },
    "sizes": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The image sizes HTML attribute"
    },
    "imageProps": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": "Additional HTML attributes to pass to the img element"
    },
    "fluid": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "If true, the image fills its container width-wise while maintaining the aspect ratio from width/height"
    }
  }
};
var FieldMessage = function FieldMessage(_ref) {
  var tone = _ref.tone,
    message = _ref.message,
    props = _objectWithoutProperties(_ref, ["tone", "message"]);
  return /*#__PURE__*/React.createElement(Inline, _extends({
    space: "xsmall"
  }, props), /*#__PURE__*/React.createElement(Icon, {
    name: tone === 'critical' ? 'info' : 'check-circle',
    size: "small",
    tone: tone
  }), /*#__PURE__*/React.createElement(Text, {
    tone: tone,
    size: "small"
  }, message));
};
FieldMessage.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FieldMessage"
};
var Input = function Input(_ref) {
  var label = _ref.label,
    className = _ref.className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    message = _ref.message,
    tone = _ref.tone,
    onChange = _ref.onChange,
    outline = _ref.outline,
    props = _objectWithoutProperties(_ref, ["label", "className", "type", "message", "tone", "onChange", "outline"]);
  var _useState = useState(!props.value),
    _useState2 = _slicedToArray(_useState, 2),
    isEmpty = _useState2[0],
    setIsEmpty = _useState2[1];
  var handleChange = useCallback(function (e) {
    if (e.target.value) {
      setIsEmpty(false);
    } else {
      setIsEmpty(true);
    }
    if (onChange) {
      onChange(e);
    }
  }, [onChange]);
  useEffect(function () {
    if (props.value && isEmpty) {
      setIsEmpty(false);
    }
  }, [props.value, isEmpty, setIsEmpty]);
  return /*#__PURE__*/React.createElement(Box, {
    className: classnames('u-input', _defineProperty({
      'u-input--empty': isEmpty,
      'u-input--outline': outline
    }, "u-input--tone-".concat(tone), tone), className)
  }, /*#__PURE__*/React.createElement(Text, {
    as: "label",
    htmlFor: props.id || "input_".concat(props.name),
    size: "small",
    tone: isEmpty || outline ? 'neutral' : 'secondary'
  }, /*#__PURE__*/React.createElement("span", null, label || ' ')), /*#__PURE__*/React.createElement(Box, _extends({
    as: "input",
    id: props.id || "input_".concat(props.name),
    type: type,
    onChange: handleChange
  }, props)), message && /*#__PURE__*/React.createElement(FieldMessage, {
    tone: tone,
    message: message,
    marginTop: "xsmall"
  }));
};
Input.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Input",
  "props": {
    "type": {
      "defaultValue": {
        "value": "'text'",
        "computed": false
      },
      "required": false
    }
  }
};
var Textarea = function Textarea(_ref) {
  var label = _ref.label,
    className = _ref.className,
    message = _ref.message,
    _ref$tone = _ref.tone,
    tone = _ref$tone === void 0 ? 'neutral' : _ref$tone,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, ["label", "className", "message", "tone", "onChange"]);
  var _useState = useState(!props.value),
    _useState2 = _slicedToArray(_useState, 2),
    isEmpty = _useState2[0],
    setIsEmpty = _useState2[1];
  var handleChange = useCallback(function (e) {
    if (e.target.value) {
      setIsEmpty(false);
    } else {
      setIsEmpty(true);
    }
    if (onChange) {
      onChange(e);
    }
  }, [onChange]);
  useEffect(function () {
    if (props.value && isEmpty) {
      setIsEmpty(false);
    }
  }, [props.value, isEmpty, setIsEmpty]);
  return /*#__PURE__*/React.createElement(Box, {
    className: classnames('u-input', 'u-input--textarea', 'u-input--outline', _defineProperty({
      'u-input--empty': isEmpty
    }, "u-input--tone-".concat(tone), tone), className)
  }, /*#__PURE__*/React.createElement(Text, {
    as: "label",
    htmlFor: props.id || "input_".concat(props.name),
    size: "small"
  }, /*#__PURE__*/React.createElement("span", null, label || ' ')), /*#__PURE__*/React.createElement(Box, _extends({
    as: "textarea",
    id: props.id || "input_".concat(props.name),
    onChange: handleChange
  }, props)), message && /*#__PURE__*/React.createElement(FieldMessage, {
    tone: tone,
    message: message,
    marginTop: "xsmall"
  }));
};
Textarea.propTypes = {
  /**
   * Renders a message below the field. Useful for validation.
   */
  message: t.string,
  /**
   * Controls the style of the given message prop.
   */
  tone: t.oneOf(['critical', 'positive', 'neutral'])
};
Textarea.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Textarea",
  "props": {
    "tone": {
      "defaultValue": {
        "value": "'neutral'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'critical'",
          "computed": false
        }, {
          "value": "'positive'",
          "computed": false
        }, {
          "value": "'neutral'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Controls the style of the given message prop."
    },
    "message": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Renders a message below the field. Useful for validation."
    }
  }
};
var Select = function Select(_ref) {
  var label = _ref.label,
    className = _ref.className,
    onChange = _ref.onChange,
    children = _ref.children,
    outline = _ref.outline,
    tone = _ref.tone,
    message = _ref.message,
    defaultSelectionProps = _ref.defaultSelectionProps,
    props = _objectWithoutProperties(_ref, ["label", "className", "onChange", "children", "outline", "tone", "message", "defaultSelectionProps"]);
  var _useState = useState(!props.value),
    _useState2 = _slicedToArray(_useState, 2),
    isEmpty = _useState2[0],
    setIsEmpty = _useState2[1];
  var handleChange = useCallback(function (e) {
    if (e.target.value) {
      setIsEmpty(false);
    } else {
      setIsEmpty(true);
    }
    if (onChange) {
      onChange(e);
    }
  }, [onChange]);
  useEffect(function () {
    if (props.value && isEmpty) {
      setIsEmpty(false);
    }
  }, [props.value, isEmpty, setIsEmpty]);
  return /*#__PURE__*/React.createElement(Box, {
    className: classnames('u-input', 'u-input--select', className, _defineProperty({
      'u-input--empty': isEmpty || props.value === '',
      'u-input--outline': outline
    }, "u-input--tone-".concat(tone), tone))
  }, /*#__PURE__*/React.createElement(Text, {
    as: "label",
    htmlFor: props.id || "input_".concat(props.name),
    size: "small",
    tone: isEmpty || outline ? 'neutral' : 'secondary'
  }, /*#__PURE__*/React.createElement("span", null, label || ' ')), /*#__PURE__*/React.createElement(Box, {
    position: "relative"
  }, /*#__PURE__*/React.createElement("select", _extends({
    id: props.id || "input_".concat(props.name),
    onChange: handleChange
  }, props), /*#__PURE__*/React.createElement("option", _extends({
    value: "",
    hidden: true
  }, defaultSelectionProps)), children), /*#__PURE__*/React.createElement(Icon, {
    name: "chevron-down",
    size: "small",
    className: "u-input--select__chevron"
  })), message && /*#__PURE__*/React.createElement(FieldMessage, {
    marginTop: "xsmall",
    tone: tone,
    message: message
  }));
};
Select.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Select"
};
var Radio = function Radio(_ref) {
  var label = _ref.label,
    tone = _ref.tone,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'regular' : _ref$size,
    className = _ref.className,
    wrapperProps = _ref.wrapperProps,
    props = _objectWithoutProperties(_ref, ["label", "tone", "size", "className", "wrapperProps"]);
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: classnames('u-input--radio', "u-input--radio--".concat(size), _defineProperty({
      'u-input--disabled': props.disabled
    }, "u-input--tone-".concat(tone), tone), className)
  }, wrapperProps), /*#__PURE__*/React.createElement(Inline, {
    as: "label",
    space: "small",
    htmlFor: props.id || "input_".concat(props.name, "_").concat(props.value)
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: props.id || "input_".concat(props.name, "_").concat(props.value),
    type: "radio"
  }, props)), /*#__PURE__*/React.createElement(Text, null, label)));
};
Radio.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Radio",
  "props": {
    "size": {
      "defaultValue": {
        "value": "'regular'",
        "computed": false
      },
      "required": false
    }
  }
};
var Checkbox = function Checkbox(_ref) {
  var label = _ref.label,
    tone = _ref.tone,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'regular' : _ref$size,
    className = _ref.className,
    wrapperProps = _ref.wrapperProps,
    props = _objectWithoutProperties(_ref, ["label", "tone", "size", "className", "wrapperProps"]);
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: classnames('u-input--checkbox', "u-input--checkbox--".concat(size), _defineProperty({
      'u-input--disabled': props.disabled
    }, "u-input--tone-".concat(tone), tone), className)
  }, wrapperProps), /*#__PURE__*/React.createElement(Inline, {
    as: "label",
    space: "small",
    htmlFor: props.id || "input_".concat(props.name)
  }, /*#__PURE__*/React.createElement(Box, {
    position: "relative"
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: props.id || "input_".concat(props.name),
    type: "checkbox"
  }, props)), /*#__PURE__*/React.createElement(Icon, {
    name: "check",
    className: "u-input--checkbox__check",
    size: "small"
  })), /*#__PURE__*/React.createElement(Text, null, label)));
};
Checkbox.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Checkbox",
  "props": {
    "size": {
      "defaultValue": {
        "value": "'regular'",
        "computed": false
      },
      "required": false
    }
  }
};
var Placeholder = function Placeholder(_ref) {
  var height = _ref.height,
    width = _ref.width,
    text = _ref.text,
    props = _objectWithoutProperties(_ref, ["height", "width", "text"]);
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: "u-placeholder",
    background: "subtle",
    justify: "center"
  }, props, {
    style: {
      width: width,
      height: height,
      padding: '0 12px'
    }
  }), text);
};
Placeholder.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Placeholder"
};
var VerticalDivider = function VerticalDivider(_ref) {
  var _ref$tone = _ref.tone,
    tone = _ref$tone === void 0 ? 'subtle' : _ref$tone,
    className = _ref.className,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, ["tone", "className", "size"]);
  var classes = classnames(className, "u-vertical-divider--".concat(tone));
  return /*#__PURE__*/React.createElement(Box, _extends({
    "aria-hidden": true,
    height: size,
    minHeight: size ? undefined : 'smallish',
    className: classes
  }, props));
};
VerticalDivider.propTypes = {
  /**
   * The color tone of the border
   */
  tone: t.string,
  /**
   * Defines the Height of the Vertical Divider
   */
  size: spacing
};
VerticalDivider.displayName = 'VerticalDivider';
VerticalDivider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "VerticalDivider",
  "props": {
    "tone": {
      "defaultValue": {
        "value": "'subtle'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The color tone of the border"
    },
    "size": {
      "type": {
        "name": "custom",
        "raw": "types.spacing"
      },
      "required": false,
      "description": "Defines the Height of the Vertical Divider"
    }
  }
};
export { ctx as BowlineContext, ThemeProvider as BowlineProvider, Box, Button, Checkbox, Column, Columns, ContentBlock, Divider, FieldMessage, Icon, Image, Inline, Input, Placeholder, Radio, ScrollBox, Select, Stack, Swatch, Text, Textarea, VerticalDivider, tokens, useTheme };